/**
 * Created by razial on 15.04.2026.
 */

const RewardedPromoRow = function (task) {
    return Prefab.instantiate(bundles.rewarded_promo_window.jsons.rewardedpromorow_prefab_json, { task });
};
